import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutLogosTitleSmall = {
  factory: EElement({
    id: 'ce06f802-19df-b7f2-bd2f-89ca9eece7a5',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('dc50ed77-8c1d-0e5d-5937-bdfab557b8ee')]),
      children: EList([
        EElement({
          id: 'ce06f802-19df-b7f2-bd2f-89ca9eece7a6',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'ea236dcf-fac6-1e44-7151-18be4becc3f7',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  text: EBoolean(true),
                  tag: EEnum('div'),
                  styleBlockIds: EList([
                    EText('7c518aca-dfba-9206-189e-52dc45df7419'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'ea236dcf-fac6-1e44-7151-18be4becc3f8',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Partners section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '0bd68d6d-20e6-77ca-676d-09c28be7ef23',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('c2899612-db53-45ce-20da-2bdedf9e87f7'),
                  ]),
                  children: EList([
                    EElement({
                      id: '27a213e5-abd8-9c6a-883a-dd0a20a95191',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ariseHealthLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('AriseHealth logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea51"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'ac8407d7-8f04-8438-987e-a915017c1d6d',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.oeLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('OE logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea60"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'a21556f1-d3a7-66cd-5bd6-ac38ee2b616f',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.twentyLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('2020INC logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea5c"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'b59861ec-64b0-24c3-389f-56e720e2e55f',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.thePaakLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('The Paak logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea4f"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: '00db61f4-be4a-816f-b3ad-dea571e34e24',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ephicientLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Ephicient logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea5b"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: '9a67bc24-f96f-6294-d3a8-b600a4661462',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.toogetherLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Toogether logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627307360779f0977d6bea55"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'dc50ed77-8c1d-0e5d-5937-bdfab557b8ee',
      type: 'class',
      name: 'Logos Title Small',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '7c518aca-dfba-9206-189e-52dc45df7419',
      type: 'class',
      name: 'Clients Tag',
      comb: '',
      styleLess:
        'margin-bottom: 32px; font-size: 14px; line-height: 20px; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'c2899612-db53-45ce-20da-2bdedf9e87f7',
      type: 'class',
      name: 'Clients Wrapper Three',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: -10px; justify-content: space-around; flex-wrap: wrap; align-items: center;',
      children: [],
      variants: {
        small: {styleLess: 'margin-bottom: -30px;'},
        tiny: {
          styleLess:
            'display: grid; margin-bottom: 0px; justify-items: center; grid-auto-columns: 1fr; grid-column-gap: 20px; grid-row-gap: 30px; grid-template-columns: 1fr 1fr; grid-template-rows: auto auto;',
        },
      },
    },
    {
      _id: 'eecbb14e-1c6a-d91c-85dd-f59dfa2f760b',
      type: 'class',
      name: 'Clients Image Three',
      comb: '',
      styleLess: 'margin-right: 15px; margin-bottom: 10px; margin-left: 15px;',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-right: 20px; margin-bottom: 30px; margin-left: 20px;',
        },
        tiny: {
          styleLess: 'margin-right: 0px; margin-bottom: 0px; margin-left: 0px;',
        },
        medium: {styleLess: 'margin-bottom: 30px;'},
      },
    },
  ],
} as const;
